<template>
    <div class="lm-border pa-3" style="position:relative;">
        <div style="position: absolute; right: 10px;">
            <div class="v-flex">
                <v-spacer />
                <v-switch
                    v-model = "favorite"
                    :ripple = "false"
                    class   = "mt-0"
                    dense
                    hide-details
                    @change = "onFavorite"
                />
            </div>
            <div class="contact-favorite-hint" v-if="favorite">
                Kontakt für Begehung
            </div>
        </div>
        <div class="contact-company primary--text">
            {{ contact.company }}
        </div>
        <div class="contact-name">
            {{ contact.name }}
        </div>
        <div class="contact-type  primary--text">
            {{ contact.type ? contact.type : "---" }}
        </div>
        <div class="contact-phone">
            <v-icon>mdi-phone</v-icon>
            <f-copy-text :text="phone(contact.phone)" v-if="contact.phone" />
            <span v-if="!contact.phone">---</span>
        </div>
        <div class="contact-phone">
            <v-icon>mdi-cellphone</v-icon>
            <f-copy-text :text="phone(contact.mobile)" v-if="contact.mobile"/>
            <span v-if="!contact.mobile">---</span>
        </div>
        <div class="contact-mail">
            <v-icon>mdi-outline</v-icon>
            <a :href = "'mailto:' + contact.email ">{{contact.email}}</a>
        </div>
    </div>
</template>

<script>

import {AsYouType} from "libphonenumber-js";
import FCopyText from "@/modules/core/components/utils/FCopyText.vue";
import Core from "@/modules/core/service/Core";

export default {
    name: "PInspectionContactCard",
    components: {
        FCopyText,
    },

    props: {
        contact: {

        }
    },

    data: () => ({
        favorite: false
    }),

    computed: {
        countries () {
            return this.$store.getters ['msd']['countries'];
        },

        selected () {
            return this.contact.favorite;
        }
    },

    mounted() {
        if (!this.contact) {
            return;
        }

        this.favorite = this.selected;
    },

    watch: {
        selected () {
            this.favorite = this.selected;
        }
    },

    methods: {
        onFavorite () {
            this.$emit("favorite", this.contact)
        },

        split (value) {
            return[ value ];
        },

        unicode (number) {
            let unicode = Core.message.language();

            if (number.startsWith("+")) {
                const countryPhone = number.substr(0, 3);
                const country = this.countries.find (c => c.phone === countryPhone);
                if (country) {
                    return country.iso3166;
                }
            }

            return unicode;
        },

        phone (number) {
            let unicode = this.unicode(number);
            if (unicode) {
                const n = number.replace("-", "").replace(" ", "")
                return new AsYouType(unicode).input(n);
            }

            return number;
        }
    }
}
</script>

<style scoped>

.contact-company {
    font-size: 11px;
}

.contact-name {
    font-size: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: calc(100% - 1px);
    margin-top: -2px;
}

.contact-type {
    font-size: 11px;
    margin-top: -2px;
    margin-bottom: 4px;
    height: 17px;
}

.contact-phone {
    margin-bottom: 2px;
    font-size: 14px;
    display: flex;
}

.contact-mail {
    font-size: 14px;
    margin-top: 1px;
}

.contact-mail a {
    text-decoration: none;
}

.contact-favorite-hint {
    font-size: 11px;
}

</style>